module.exports = __webpack_public_path__ + "static/img/3_1_5.b3dca285.jpg";